<template>
  <div v-if="loaded" class="print-main">
    <div class="print-left" :style="{ height: `${this.$util.getViewHeight() - 36 - 162}px` }">
      <div id="print-content" class="print-content">
        <!-- title -->
        <div class="title-box">
          <h1 class="title-main">{{ $constant.company_info.company_name }}</h1>
          <div class="m-t-5">
            <span>联系地址：{{ $constant.company_info.company_address }}</span>
            <span class="m-l-10">联系电话：{{ $constant.company_info.company_phone }}</span>
          </div>
          <h2 class="title-sub">
            <span>生产工单</span>
            <span class="title-number">
              (<span>NO.</span>
              <span class="title-red">{{ detailData.formData.gong_dan_code }}</span
              >)
            </span>
          </h2>
        </div>

        <!-- formData -->
        <div class="form-main">
          <div class="form-list" v-for="(itemSt, indexSt) in formData" :key="indexSt">
            <div
              :class="{ 'form-item': true, 'flex-sub': indexNd === 2 }"
              v-for="(itemNd, indexNd) in itemSt"
              :key="indexNd"
            >
              <div class="form-key">{{ itemNd.key }}{{ itemNd.key && '：' }}</div>
              <div class="form-val" v-if="itemNd.val">
                <span
                  v-if="
                    itemNd.val === 'jiao_huo_ri_qi' ||
                    itemNd.val === 'sheng_chan_end_date' ||
                    itemNd.val === 'create_date'
                  "
                >
                  {{
                    detailData.formData[itemNd.val]
                      ? detailData.formData[itemNd.val].slice(0, 10)
                      : '&nbsp;'
                  }}
                </span>
                <span v-else>
                  {{ detailData.formData[itemNd.val] || '&nbsp;' }}
                </span>
                <span
                  v-if="itemNd.val === 'company_id' && detailData.formData.customer_rating"
                  class="c-red"
                  >({{ detailData.formData.customer_rating }})</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- tableData -->
        <div class="table-main">
          <PrintTable
            v-if="detailData.tableSaleData && detailData.tableSaleData.length"
            :data="detailData"
            :gongyiData="detailData.gongyiData"
          />
        </div>

        <!-- 签章：人员签字区 -->
        <div class="gai-zhang-box">
          <div class="gai-zhang-cont">
            <div class="gai-zhang-item">业务员：{{ detailData.formData.saler_name || '' }}</div>
            <div class="gai-zhang-item"></div>
          </div>
          <div class="gai-zhang-cont">
            <div class="gai-zhang-item">
              生产人员：{{ detailData.formData.sheng_chan_ren_yuan_name || '' }}
            </div>
            <div class="gai-zhang-item"></div>
          </div>
          <div class="gai-zhang-cont">
            <div class="gai-zhang-item">制单人：{{ detailData.formData.create_name || '' }}</div>
            <div class="gai-zhang-item"></div>
          </div>
          <div class="gai-zhang-cont">
            <div class="gai-zhang-item">出货人：</div>
            <div class="gai-zhang-item"></div>
          </div>
          <div class="gai-zhang-cont">
            <div class="gai-zhang-item">审核人：</div>
            <div class="gai-zhang-item"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="print-right">
      <div class="print-do">
        <div>
          <el-button
            class="print-btn"
            v-print="printData"
            type="primary"
            size="small"
            @click="printLog"
          >
            打印
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrintTable: () => import('./print-table')
  },
  data() {
    return {
      loaded: false,
      detailData: {},
      printData: {
        id: 'print-content',
        popTitle: '&nbsp;'
      },
      formData: [
        [
          {
            key: '订单编号',
            val: 'bill_code'
          },
          {
            key: '客户',
            val: 'company_id'
          },
          {
            key: '交货日期',
            val: 'jiao_huo_ri_qi'
          },
          {
            key: '生产交期',
            val: 'sheng_chan_end_date'
          }
        ],
        [
          {
            key: '生产班组',
            val: 'banzu_name'
          },
          {
            key: '优先级',
            val: 'xxx'
          },
          {
            key: '订单类型',
            val: 'ding_dan_lei_xing'
          },
          {
            key: '制单日期',
            val: 'create_date'
          }
        ]
      ]
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  mounted() {
    this.getDetailData()
  },
  methods: {
    // 打印登记：记录是否打印与打印次数
    printLog() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/shengChanGongDan/printLog',
        params: {
          id: this.id
        }
      }).catch(() => {})
    },
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      let url = '/admin/gcvip/shengChanGongDan/detail'
      await this.$api({
        method: 'get',
        url,
        params: {
          id: this.id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          this.detailData = result
        }
      })
      this.loaded = true
    }
  }
}
</script>

<style lang="less" scoped>
// print
.print-main {
  display: flex;
  background: #f5f7fa;
  .print-left {
    margin: 10px;
    padding: 20px;
    width: 712px;
    background: #fff;
    overflow-y: auto;
    .scroll-bar();
  }
  .print-right {
    margin: 10px 10px 10px 0;
    padding: 10px;
    width: 200px;
    background: #fff;
    .print-btn {
      width: 100%;
    }
    .print-do {
      margin-bottom: 20px;
      padding: 20px;
      text-align: center;
      font-size: 14px;
      background: #f8f8f8;
    }
  }
}

// content
.print-content {
  font-size: 12px;
  line-height: 1.5;
  font-family: 'Arial,Microsoft YaHei,SimHei,SimSun';
  overflow: hidden;
}

// title
.title-box {
  margin: 10px 0 20px 0;
  text-align: center;
}
.title-main {
  margin: 0;
  font-size: 24px;
}
.title-sub {
  position: relative;
  margin: 10px 0 0 0;
  font-size: 20px;
}
.title-number {
  // position: absolute;
  // top: 0;
  // right: 0;
}
.title-red {
  color: #cf2438;
}

// form
.form-main {
  display: flex;
  margin-top: 10px;
  flex-direction: column;
}
.form-list {
  flex: 1;
  display: flex;
  .form-item {
    flex: 1;
    display: flex;
    align-items: center;
    &.form-st {
      font-weight: bold;
    }
    .form-key {
      border-bottom: 1px solid #fff;
    }
    .form-val {
      flex: 1;
      padding: 2px 0;
      border-bottom: 1px solid #000;
    }
  }
}

// table
.table-main {
  margin-top: 10px;
}

// 签章
.gai-zhang-box {
  display: flex;
  margin-top: 40px;
  padding-top: 20px;
  font-size: 14px;
  border-top: 1px solid #000;
  .gai-zhang-cont {
    flex: 1;
    .gai-zhang-item {
      & ~ .gai-zhang-item {
        margin-top: 10px;
      }
    }
  }
}
</style>
